// Action
// =============================================================================
export let Action;
(function (_Action) {
  let Type = /*#__PURE__*/function (Type) {
    Type["ReceivedDownloadPrintableCheck"] = "ReceivedDownloadPrintableCheck";
    Type["RequestDownloadPrintableCheck"] = "RequestDownloadPrintableCheck";
    Type["UserClickDismissPrintableCheckBlade"] = "UserClickDismissPrintableCheckBlade";
    Type["UserClickDownloadCheck"] = "UserClickDownloadCheck";
    Type["UserClickPrintCheck"] = "UserClickPrintCheck";
    return Type;
  }({});
  _Action.Type = Type;
})(Action || (Action = {}));
// Action creators
// -----------------------------------------------------------------------------
export let ActionCreator;
(function (_ActionCreator) {
  const receivedDownloadPrintableCheck = _ActionCreator.receivedDownloadPrintableCheck = response => ({
    type: Action.Type.ReceivedDownloadPrintableCheck,
    response
  });
  const requestDownloadPrintableCheck = _ActionCreator.requestDownloadPrintableCheck = printableCheckId => ({
    type: Action.Type.RequestDownloadPrintableCheck,
    printableCheckId
  });
  const userClickDismissPrintableCheckBlade = _ActionCreator.userClickDismissPrintableCheckBlade = () => ({
    type: Action.Type.UserClickDismissPrintableCheckBlade
  });
  const userClickDownloadCheck = _ActionCreator.userClickDownloadCheck = printableCheckId => ({
    type: Action.Type.UserClickDownloadCheck,
    printableCheckId
  });
  const userClickPrintCheck = _ActionCreator.userClickPrintCheck = printableCheckId => ({
    type: Action.Type.UserClickPrintCheck,
    printableCheckId
  });
})(ActionCreator || (ActionCreator = {}));